export default __webpack_public_path__ + "static/media/KY.ac10b351.svg";